module.exports = __webpack_public_path__ + "media/icons/checkbox-green-checked-24f42763.svg";